var $body   = $(document.body);
var navHeight = $('#sidebar').outerHeight(true) + 10;

$('.designguide #sidebar').affix({
    offset: {
        top: 398,
        bottom: navHeight
    }
});

var menu = $(".designguide__navigation ul"),
    menuHeight = menu.outerHeight() + 15,
    menuItems = menu.find("ul a"),
    scrollItems = menuItems.map(function () {
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
    });

function checkMenu() {
    var fromTop = $(this).scrollTop();
    var cur = scrollItems.map(function () {
        if ($(this).offset().top+15 > fromTop)
            return this;
    });

    cur = cur[0];

    var id = cur && cur.length ? cur[0].id : "";

    menuItems.parent().removeClass("current");
    menuItems.parent().parent().parent().removeClass("current");

    menuItems.filter("[href='#" + id + "']").parent().addClass("current");
    menuItems.filter("[href='#" + id + "']").parent().parent().parent().addClass("current");

    if (history.pushState) {
        history.pushState(null, null, "#" + id);
    }
}
$(window).scroll(function () {
    checkMenu();
});
